import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  '@global': {
    '.MuiAutocomplete-popper .MuiAutocomplete-option': {
      textTransform: 'uppercase',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      '& .MuiOutlinedInput-input': {
        // padding: '10px !important',
        textTransform: 'uppercase',
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      },
      '& .Mui-disabled': {
        // cursor: 'not-allowed', // Mostra o ícone de proibido ao passar o mouse
        opacity: 0.8 // Dá um tom levemente acinzentado
      }
    },
    '& label': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  chip: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.primary.contrastText,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
}))
